import React, { useState, useRef, useEffect } from 'react'
import styles from './styles'
import { withStyles } from '@material-ui/core'
import {
  llmUploadAttachmentAction,
  llmCheckAttachmentStatusAction,
  llmSetChatId,
} from 'src/reducers/llm/action'
import { useDispatch, useSelector } from 'react-redux'
import { AttachmentView } from './components'
import NonAttachmentView from 'src/components/non-attachment-view'
import { track } from '@amplitude/analytics-browser'
const FileUpload = props => {
  const { attachmentLoading, setAttachmentLoading } = props
  const dispatch = useDispatch()
  const attachments = useSelector(state => state.llmContent.attachments)
  const fileInputRef = useRef(null)
  const [isChecking, setIsChecking] = React.useState(false) // Flag to track pending request
  const [chatId, setChatId] = useState(null)
  const attachmentsToCheck = attachments.filter(
    attachment =>
      attachment.succeeded === false &&
      attachment.upload_status !== 'partial_failure' &&
      attachment.upload_status !== 'failed',
  )

  const handleOnDropFile = e => {
    track('upload_attachment')

    e.preventDefault()
    const file = e.dataTransfer.files[0]
    if (file) {
      uploadFile(file) // You can handle the upload here
    }
  }

  const handleFileSelect = e => {
    const selectedFile = e.target.files[0]
    if (selectedFile) {
      uploadFile(selectedFile) // You can handle the upload here
    }
  }

  const uploadFile = file => {
    track('upload_attachment')
    const allowedExtensions = ['pdf', 'txt']
    const fileExtension = file.name.split('.').pop().toLowerCase()

    if (!allowedExtensions.includes(fileExtension)) {
      alert('Invalid file type. Please select a PDF or TXT file.')
      return
    }
    setAttachmentLoading(true)
    const formData = new FormData()
    formData.append('file', file)
    chatId != null && formData.append('chatId', chatId)
    dispatch(
      llmUploadAttachmentAction(formData, file.name, res => {
        setAttachmentLoading(false)
        if (chatId == null) {
          setChatId(res.chat_id)
          dispatch(llmSetChatId(res.chat_id))
        }
      }),
    )
  }

  const checkAttachmentStatus = async () => {
    if (!isChecking && attachmentsToCheck.length > 0) {
      setIsChecking(true) // Set flag before making the request
      for (const attachment of attachmentsToCheck) {
        dispatch(
          llmCheckAttachmentStatusAction(
            chatId,
            attachment.attachment_id,
            response => {
              if (response.succeeded) {
              }
            },
          ),
        )
      }
      setIsChecking(false) // Reset the flag after request completes
    }
  }

  useEffect(() => {
    const interval = setInterval(checkAttachmentStatus, 3000)
    return () => clearInterval(interval)
  }, [attachmentsToCheck])

  return (
    <>
      {attachments.length > 0 ? (
        <AttachmentView
          attachments={attachments}
          handleOnDropFile={handleOnDropFile}
          fileInputRef={fileInputRef}
          handleFileSelect={handleFileSelect}
          attachmentLoading={attachmentLoading}
        />
      ) : (
        <NonAttachmentView
          handleOnDropFile={handleOnDropFile}
          fileInputRef={fileInputRef}
          handleFileSelect={handleFileSelect}
          attachmentLoading={attachmentLoading}
        />
      )}
    </>
  )
}

export default withStyles(styles)(FileUpload)
